export function fontSize(designWidth, diyFontSize) {
    var dpr = window.devicePixelRatio;
    var scale = 1 / dpr;
    var metaEle = document.createElement('meta');
    metaEle.name = 'viewport';
    metaEle.content =
        'width=device-width,initial-scale=' +
            scale +
            ',maximum-scale=' +
            scale +
            ',minimum-scale=' +
            scale +
            ',user-scalable=no';
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(metaEle);
    var html = document.getElementsByTagName('html')[0];
    var clientSize = document.documentElement.clientWidth;
    if (typeof window.orientation === 'number' &&
        typeof window.onorientationchange === 'object') {
        var isLandscape = window.matchMedia('(orientation: landscape)').matches;
        if (isLandscape) {
            clientSize =
                document.documentElement.clientHeight *
                    (/(Android)/i.test(navigator.userAgent) ? 1.25 : 1);
        }
    }
    var result = (diyFontSize * clientSize) / designWidth;
    html.style.fontSize = result + 'px';
    return result;
}
export var updateOrientation = function () {
    var orientation;
    if (typeof window.orientation === 'number' &&
        typeof window.onorientationchange === 'object') {
        switch (window.orientation) {
            case 90:
            case -90:
                orientation = 'landscape';
                break;
            default:
                orientation = 'portrait';
        }
    }
    else {
        orientation =
            window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
    }
    return orientation;
};
var ua = navigator.userAgent;
export var isOnIPhone = /(iPhone|iPad|iPod|iOS)/i.test(ua) ||
    (/Macintosh/i.test(ua) && ua.toLocaleLowerCase().indexOf('chrome') === -1);
export var setNewsit = function (id) {
    if (id === '1001' || id === '2001' || id === '3001' || id === '4001'
        || id === '5200' || id === '5000'
        || id > 5200) {
        return true;
    }
    return false;
};
export var setNewsit2 = function (id) {
    if (id === '1001' || id === '2001' || id === '3001' || id === '4001'
        || id === '5200' || id === '5000'
        || id > 5200) {
        return false;
    }
    return true;
};
export var getSITEID = function (id) {
    id = String(id);
    // 异常类型处理
    var siteidstauts = id === '1001' || id === '2001' || id === '3001' || id === '4001';
    if (!siteidstauts) {
        id = '1001';
    }
    return id;
};
